<template>

    <inputtype
        v-if="field.type === 'input'"
        :field="field"
        @input="$emit('input', $event)"
        :value="value"
        :show-error="hasError"
    ></inputtype>
    <textareatype
        v-else-if="field.type === 'textarea'"
        :field="field"
        @input="$emit('input', $event)"
        :value="value"
        :show-error="hasError"
    ></textareatype>
    <emailtype
        v-else-if="field.type === 'email'"
        :field="field"
        @input="$emit('input', $event)"
        :value="value"
        :show-error="hasError"
    ></emailtype>

</template>

<script>

import Inputtype from './Types/Inputtype';
import Textareatype from './Types/Textareatype';
import Emailtype from './Types/Emailtype';

export default {

    components: {
        Inputtype,
        Textareatype,
        Emailtype,
    },

    computed: {
        allErrors() {
            return this.$page.props.errors;
        },

        hasError() {
            return !!this.allErrors[this.field.uuid];
        },
    },

    name:'ContactformField',

    props: {
        field: {
            type:Object,
            required:true,
        },
        value: {
            required:true,
        },
    },
}

</script>
